/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-10 12:29:02
 * @Explain: 活动
 */
export default {
  // 活动列表
  'ACTIVITY.MANAGE.LIST.TITLE': '活动列表',
  'ACTIVITY.MANAGE.LIST.CREATE.CAMPAIGN': '创建活动',
  'ACTIVITY.MANAGE.LIST.TASK.NAME': '名称',
  'ACTIVITY.MANAGE.LIST.CHANNEL': '触达渠道',
  'ACTIVITY.MANAGE.LIST.EDITOR': '最近编辑人',
  'ACTIVITY.MANAGE.LIST.TIME.ZONE': '时区',
  'ACTIVITY.MANAGE.LIST.START.TIME': '开始时间',
  'ACTIVITY.MANAGE.LIST.ACTIVITY.START.TIME': '活动开始时间',
  'ACTIVITY.MANAGE.LIST.END.TIME': '结束时间',
  'ACTIVITY.MANAGE.LIST.UPDATE.TIME': '编辑时间',
  'ACTIVITY.MANAGE.LIST.VERIFY.STATUS': '验证状态',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS': '状态',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS1': '变量值缺失，活动已暂停',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS2': '点击资源码名称为其上传变量值：',
  'ACTIVITY.MANAGE.LIST.TASK.STATUS.TIPS3':
    '已达到24小时内发件量最大值，余额自动刷新，余额刷新后活动自动开始',
  'ACTIVITY.MANAGE.LIST.STATUS.DESC': '活动状态说明',
  'ACTIVITY.MANAGE.LIST.DELETE.CAMPAIGN.TIPS':
    '旅程 {campaignName} 内条件判断节点使用中',

  'ACTIVITY.MANAGE.LIST.RECIPIENTS': '收件人',
  'ACTIVITY.MANAGE.LIST.DATA.UPDATE.TIME': '数据更新时间',
  'ACTIVITY.MANAGE.LIST.SEND.PROGRESS': '发送进度',
  'ACTIVITY.MANAGE.LIST.CAMPAIGN.NOT.STARTED': '未开始',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED': '发件速度',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED.TIPS1':
    '平均发件速度，速度随送达情况动态变化。',
  'ACTIVITY.MANAGE.LIST.DISPATCH.SPEED.TIPS2': '预估结束时间同步更新。',
  'ACTIVITY.MANAGE.LIST.SEAL.SECOND': '<b>{num}</b>封/秒',
  'ACTIVITY.MANAGE.LIST.ESTIMATED.TIME.OF.END': '预估结束时间',
  'ACTIVITY.MANAGE.LIST.NO.CYCLE.USER': '当前周期无符合条件用户',
  'ACTIVITY.MANAGE.LIST.CYCLE.NOT.ACTIVE': '此周期活动未进行',
  'ACTIVITY.MANAGE.LIST.PAUSE.CYCLE.NOT.ACTIVE':
    '错过活动发送时间，已手动确认跳过此周期。',
  'ACTIVITY.MANAGE.LIST.CYCLE': '周期',

  'ACTIVITY.MANAGE.LIST.WINNER.DELIVERY.IN.PROGRESS': '获胜组投递中',
  'ACTIVITY.MANAGE.LIST.WAITLIST': '排队中',
  'ACTIVITY.MANAGE.LIST.WAITLIST.NOTES':
    '进行中的活动，但等待收件人所在时区的设定时间后投递，或处于免打扰时段内等待投递。',
  'ACTIVITY.MANAGE.LIST.RECOVER.REMAINING.TIME':
    '<span class="color-d6">排队等待下个时区启动或免打扰时段内。</span><br/><b> 剩余{time}</b>',
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS.SENDING': '测试中（正在发送）',
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS.PENDING.WINNER.SELECTION':
    '测试中（等待获胜组选择）',
  'ACTIVITY.MANAGE.LIST.WAITING.FOR.EXECUTION': '等待执行',
  'ACTIVITY.MANAGE.LIST.SCHEDULED.NOTES':
    '活动发布成功，但是未到设置的发送时间，未开始投递。',
  'ACTIVITY.MANAGE.LIST.TESTINPROGRESS': '测试中',
  'ACTIVITY.MANAGE.LIST.TESTINPROGRESS.NOTES':
    'AB测试活动开始后，实验组投递中，等待获胜组选出。',
  'ACTIVITY.MANAGE.LIST.TERMINATED': '已完成',
  'ACTIVITY.MANAGE.LIST.TERMINATED.NOTES': '活动完毕正常结束。',
  'ACTIVITY.MANAGE.LIST.TERMINATION.NOTES': '活动被手动终止。',
  'ACTIVITY.MANAGE.LIST.HAVE.ON.GOING': '进行中',
  'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND': '发送中',
  'ACTIVITY.MANAGE.LIST.HAVE.IN.HAND.NOTES':
    '活动被发布成功，且已经到达设置的发送时间，正常投递中。',
  'ACTIVITY.MANAGE.LIST.UNPUBLISHED': '草稿',
  'ACTIVITY.MANAGE.LIST.UNPUBLISHED.NOTES':
    '活动为未创建完成，暂存状态，编辑后可直接发布或申请发布。',
  'ACTIVITY.MANAGE.LIST.START': '开始',
  'ACTIVITY.MANAGE.LIST.NOT.STARTED': '未开始',
  'ACTIVITY.MANAGE.LIST.SUSPENDED': '已暂停',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.NOTES':
    '进行中的活动，被手动暂停。当前不再发送邮件',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER': '发送中断',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.MISSING.PLACEHOLDER.NOTES':
    '发送中的活动，但由于资源码缺失等其他问题导致发送被中断。',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL': '审批中',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.NOTES': '活动已申请发布，等待审批中。',
  'ACTIVITY.MANAGE.LIST.FAILED': '未通过',
  'ACTIVITY.MANAGE.LIST.VERIFIED': '已验证',
  'ACTIVITY.MANAGE.LIST.NOT.VERIFIED': '未验证',
  'ACTIVITY.MANAGE.LIST.VERIFYING': '验证中',
  'ACTIVITY.MANAGE.LIST.SELECT.TIME': '选择时间',
  'ACTIVITY.MANAGE.LIST.SEARCH.TASK.NAME': '请输入活动名称',
  'ACTIVITY.MANAGE.LIST.DELETE.HEADER': '确定删除活动？',
  'ACTIVITY.MANAGE.LIST.DELETE.CONTENT':
    '删除 <b class="color-333">{name}</b> 后，活动信息及报表数据均被删除且不可恢复。',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.HEADER': '确定批量删除活动？',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONTENT':
    '已选中 <b class="color-333">{num}</b> 个活动，删除后，所有选中活动信息均被删除且不可恢复。',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONFIRM': '输入 <b>删除</b> 以确定此操作',
  'ACTIVITY.MANAGE.LIST.BATCH.DELETE.CONFIRM.TEXT': '删除',
  'ACTIVITY.MANAGE.LIST.DELETE.TIPS': '删除前请检查内容',
  // 'ACTIVITY.MANAGE.LIST.REVOKE.MSG': '是否撤销吗？',
  'ACTIVITY.MANAGE.LIST.REVOKE.TITLE': '确定撤销活动？',
  'ACTIVITY.MANAGE.LIST.REVOKE.MSG':
    "<b class='color-333'>{name}</b>已提交，撤销后需重新提交申请。",

  'ACTIVITY.MANAGE.LIST.START.TITLE': '开始',
  'ACTIVITY.MANAGE.LIST.START.TIPS': '是否开始任务{name}',
  'ACTIVITY.MANAGE.LIST.SUSPENDED.TIPS': '是否暂停任务{name}',
  'ACTIVITY.MANAGE.LIST.TERMINATION.TIPS': '终止任务{name}该任务将不再执行',

  'ACTIVITY.MANAGE.LIST.TIMEZONE': '时区',
  'ACTIVITY.MANAGE.LIST.START.DELIVERY.TIME1': '开始时间(当地时间)',
  'ACTIVITY.MANAGE.LIST.START.DELIVERY.TIME2': '开始时间',

  'ACTIVITY.MANAGE.LIST.ACTIVITY.DETAILS': '活动详情',
  'ACTIVITY.MANAGE.LIST.APPROVAL.DETAILS': '审批详情',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS': '周期详情',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.RELEASE': '发布活动',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.EDIT': '修改活动',
  'ACTIVITY.MANAGE.LIST.CYCLE.DETAILS.ENDS.AT': '结束时间',
  'ACTIVITY.MANAGE.LIST.ALL.WEIGHT.REMOVAL': '活动内所有周期去重',
  'ACTIVITY.MANAGE.LIST.WEIGHT.IN.DAYS': '{num}天内去重',
  'ACTIVITY.MANAGE.LIST.PERIOD.NUM': '周期{num}',
  'ACTIVITY.MANAGE.LIST.UNSENT': '未发送',
  'ACTIVITY.MANAGE.LIST.BEING.SENT': '发送中',
  'ACTIVITY.MANAGE.LIST.SENT': '已发送',
  'ACTIVITY.MANAGE.LIST.UNSENT.REASON': '活动暂停，周期被跳过',
  'ACTIVITY.MANAGE.LIST.TOTAL.PEOPLE.SENT':
    '已发送总人数<b class="ml-4">{num}</b>',
  'ACTIVITY.MANAGE.LIST.APPROVAL.STATUS': '审批状态',
  'ACTIVITY.MANAGE.LIST.COPY.APPROVAL.LINK': '复制审批链接',
  'ACTIVITY.MANAGE.LIST.COPY.APPROVAL.TEXT':
    '您好，\r活动已经提交，请您尽快审批。\r项目名称：{gameName}\r活动名称：{activityName}\r申请人：{activityCreator}\r申请时间：{createTime}\r快速审批入口：（去审批-页面）{checkLink}',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS1':
    '发布申请已提交，以下Smartlink管理员用户具备审批权限，如需加快审批进度，可进行',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS2': '操作',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS3':
    '或催办以下用户，催办后smartlink会发送邮件提醒用户审批，两次催办时间需间隔30分钟；',
  'ACTIVITY.MANAGE.LIST.UNDER.APPROVAL.TIPS4':
    '若需修改活动内容可联系管理员驳回申请；',
  'ACTIVITY.MANAGE.LIST.VIEW.REPORT': '查看报表',
  'ACTIVITY.MANAGE.LIST.APPROVED.STATUS': '审批状态',
  'ACTIVITY.MANAGE.LIST.APPROVED.BY': '审批人',
  'ACTIVITY.MANAGE.LIST.APPROVED.TIME': '审批时间',
  'ACTIVITY.MANAGE.LIST.REASON.FOR.PASSING': '通过原因',
  'ACTIVITY.MANAGE.LIST.REASON.FOR.FAILURE': '未通过原因',
  'ACTIVITY.MANAGE.LIST.REJECTED.RE.ISSUED': '活动被驳回后，建议调整后重新发布',
  'ACTIVITY.MANAGE.LIST.SCHEDULED': '已计划',
  'ACTIVITY.MANAGE.LIST.REVOKE.SCHEDULED.CONTENT':
    "<b class='color-333'>{tag}</b>已发布，撤销后需重新发布。",
  'ACTIVITY.MANAGE.LIST.TEST.IN.PROGRESS': '测试中',
  'ACTIVITY.MANAGE.LIST.PROGRESS': '进程',
  'ACTIVITY.MANAGE.LIST.WINNING.SETUP.SENT.AT': '获胜组发送时间',
  'ACTIVITY.MANAGE.LIST.SELECT.MANUALLY': '手动选择',
  'ACTIVITY.MANAGE.LIST.ONGING': '正在运行',
  'ACTIVITY.MANAGE.LIST.END': '已结束',
  // 'ACTIVITY.MANAGE.LIST.AUTOMATIC.SELECTION': '自动选择',
  'ACTIVITY.MANAGE.LIST.HOW.MANY.HOURS': '测试完成后{num}小时',
  'ACTIVITY.MANAGE.LIST.HOW.MANY.DAYS': '测试完成后{num}天',

  // 活动管理 - 列表 - 创建活动
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY': '创建活动',
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY.NAME': '活动名称',
  'ACTIVITY.MANAGE.LIST.CREATE.PLEASE.ENTER.ACTIVITY.NAME': '输入名称',
  'ACTIVITY.MANAGE.LIST.CREATE.PLEASE.ENTER.ACTIVITY.NAME.ERROR.EMOJI':
    '名称不能包含任何表情符号',
  'ACTIVITY.MANAGE.LIST.CREATE.ACTIVITY.DESC1':
    '创建并发布活动，在几分钟内可以完成选择收件人、发送人、模板、设置发送时间。',

  // 创建活动 - 合规
  'ACTIVITY.MANAGE.COMPLIANCE.DESC':
    '为提升订阅者忠诚度，避免用户投诉及违规风险，我们建议您采用“许可式电子邮件营销”发送活动邮件，并请注意以下事项：',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS1':
    '1. 仅向已选择接收邮件的用户发送营销邮件，确保联系人列表的订阅状态真实有效；',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS2':
    '2. 发件人名称和邮箱地址需准确无误，方便用户了解信息来源；',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS3':
    '3. 主题行需准确反映邮件内容，不得误导用户；',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS4': '4. 邮件信息中需包含真实的邮政地址；',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS5': '5. 邮件信息中需包含清晰醒目的退订说明。',
  'ACTIVITY.MANAGE.COMPLIANCE.TIPS6':
    '如需了解更多电子邮件营销政策及法律风险，请咨询pdp_intlpdp@tencent.com。',

  // 活动管理 - 创建活动 - 完成配置
  'ACTIVITY.MANAGE.CREATE.COMPLETE.CONFIG.TITLE': '完成以下设置',
  'ACTIVITY.MANAGE.CREATE.COMPLETE.CONFIG.TIPS':
    '完成以下设置后再创建活动将加快创建速度。',
  'ACTIVITY.MANAGE.CREATE.TO.CREATE': '去创建',
  'ACTIVITY.MANAGE.CREATE.TO.VERIFY': '去验证',
  'ACTIVITY.MANAGE.CREATE.TO.IMPORT': '去导入',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT': '导入联系人',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT.TIPS1':
    '联系人是您活动可能选中的收件人。',
  'ACTIVITY.MANAGE.CREATE.SET.CONTACT.TIPS2':
    'SmartLink 支持您通过标签或分层规则筛选符合条件的联系人。在此之前，您需要先导入联系人并为其绑定标签或创建好的分层规则。',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME': '验证域名',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME.TIPS1':
    '域名是您发件邮箱地址中“@”后的部分。',
  'ACTIVITY.MANAGE.CREATE.SET.DOMAIN.NAME.TIPS2':
    '在使用SmartLink发送电子邮件之前，您必须完成域名验证。',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP': '创建邮件模板',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP.TIPS1':
    '邮件模板是您发出的邮件内容，同一活动下支持发出多语言版本邮件。',
  'ACTIVITY.MANAGE.CREATE.SET.EMAIL.TEMP.TIPS2':
    '提前创建好模板，可在创建活动时直接选中需要发送的邮件内容。',
  'ACTIVITY.MANAGE.CREATE.NO.CONTACTS': '还未有联系人?',
  'ACTIVITY.MANAGE.CREATE.NO.CONTACTS.TIPS':
    '您可以创建联系人以进行更好的管理。我们将引导您完成此过程。',
  'ACTIVITY.MANAGE.CREATE.CREATE.CONTACTS': '创建联系人',

  // 活动管理 - 创建活动 - 操作按钮（草稿、发送测试邮件、现在发送、申请发布）
  'ACTIVITY.MANAGE.CREATE.SAVE.QUIT': '保存并退出',
  'ACTIVITY.MANAGE.CREATE.SAVE.QUIT.TIPS': '请先确认修改内容',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT': '草稿保存于 {time}',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT.TITLE': '确定是否保存修改内容?',
  'ACTIVITY.MANAGE.CREATE.SAVE.DRAFT.DESC':
    '选择不保存，您修改的内容将被删除且不可恢复。',
  'ACTIVITY.MANAGE.CREATE.SEND.NOW': '发布',
  'ACTIVITY.MANAGE.CREATE.APPLICATION.RELEASE': '申请发布',
  'ACTIVITY.MANAGE.PUBLISH.TIPS': '请完成发送电子邮件所需的所有步骤',
  'ACTIVITY.MANAGE.PUBLISH.WHATSAPP.TIPS':
    '请完成发送WhatsApp消息所需的所有步骤',
  'ACTIVITY.MANAGE.CREATE.SUBMIT.RELEASE.APPLY': '确定申请活动发布？',
  'ACTIVITY.MANAGE.CREATE.SUBMIT.RELEASE.APPLY.TIPS1':
    '申请提交后，可在待审批活动列表查看审批状态，仅当审批通过后活动才会发布。',
  'ACTIVITY.MANAGE.CREATE.DIRECT.RELEASE.ACTIVITY': '确定发布活动？',
  'ACTIVITY.MANAGE.CREATE.DIRECT.RELEASE.ACTIVITY.TIPS1':
    '活动发布后，信息不可修改。建议完成活动预览及测试后发布。',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.LABEL': '请选择活动目的',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.PREFIX.LABEL': '目的',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.SELECT': '请选择活动目的',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.ENTER': '请填写活动目的',
  'ACTIVITY.MANAGE.CREATE.TEST.PERIOD': '试验周期',
  'ACTIVITY.MANAGE.CREATE.PLAYER.ACTIVATION': '玩家激活',
  'ACTIVITY.MANAGE.CREATE.PLAYER.PAYMENT': '玩家付款',
  'ACTIVITY.MANAGE.CREATE.OTHERS': '其他',
  'ACTIVITY.MANAGE.CREATE.PURPOSE.TIPS1':
    '请选择活动目的以精准分析效果，您的选择将仅用于报表，不会泄露给第三方。',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TITLE': '跳过防打扰策略',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS1':
    '勾选后此活动玩家收件不计入防打扰策略。',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS2': '点击此处',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.TIPS3': '进入防打扰策略页面',
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.SIGN.ON':
    "<a href={url} target='_black'>防打扰策略</a>保护中",
  'ACTIVITY.MANAGE.CREATE.ANTI.DISTURB.SIGN.OFF':
    "跳过<a href={url} target='_black'>防打扰策略</a>",

  // 预览并测试 - 验证活动 - start
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEST': '预览并测试',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEST.TIPS': '请完成所有必需的步骤以查看预览',
  'ACTIVITY.MANAGE.TEST.MAIL.SEND.FOR.TEST': '发送测试邮件',
  'ACTIVITY.MANAGE.TEST.MAIL.SEND.TEST.LIST':
    '模板中资源码：设置测试邮件的资源码的替换值',
  'ACTIVITY.MANAGE.ENTER.VERIFY.MAILBOX': '输入验证邮箱',
  'ACTIVITY.MANAGE.PLEASE.ENTER.VERIFY.MAILBOX': '请输入验证邮箱',
  'ACTIVITY.MANAGE.SUBMIT.TOTAL.MAIL':
    '共计<b class="ml-5 mr-5">{num}</b>个验证邮箱地址',
  'ACTIVITY.MANAGE.SEND.TEST.EMAIL': '发送测试邮件',
  'ACTIVITY.MANAGE.SEND.MAIL': '发送邮件',
  'ACTIVITY.MANAGE.MAIL.SEND.COMPLETE': '邮件发送成功',
  'ACTIVITY.MANAGE.MAIL.SEND.RESULT': '模板邮件发送完成，请查收邮件',
  'ACTIVITY.MANAGE.VERIFY.PASSED': '验证通过',
  'ACTIVITY.MANAGE.VERIFY.FAILED': '验证不通过',
  'ACTIVITY.MANAGE.SUBMIT.VERIFY.RESSULTS.LATER': '稍后提交验证结果',
  'ACTIVITY.MANAGE.SELECT.VERIFY.EMAIL': '请选择验证人邮箱',
  'ACTIVITY.MANAGE.ENTER.VERIFY.EMAIL': '请输入验证人邮箱',
  'ACTIVITY.MANAGE.ENTER.VERIFY.EMAIL.EMPTY': '字段不能为空',
  'ACTIVITY.MANAGE.TEMPLATE.VAR': '模板变量',
  'ACTIVITY.MANAGE.VAR': '变量',
  'ACTIVITY.MANAGE.REPLACE.WITH': '替换为',
  'ACTIVITY.MANAGE.VAR.REPLACE.WITH':
    '变量 <b class="color-333">{name}</b> 替换为',
  'ACTIVITY.MANAGE.PLEASE.ENTER.REPLACE.VALUE': '请输入替换值',
  'ACTIVITY.MANAGE.DEFAULT.VAR.TIPS': '{var}为默认变量，可根据需要替换变量',
  'ACTIVITY.MANAGE.CLICK.VERIFY.MAIL.MANAGE': '请点击验证邮箱管理，添加验证人',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS1': '此语种未配置，可',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS2': '前往配置',
  'ACTIVITY.MANAGE.LANG.NOT.CONFIG.TIPS3': '，或在输入框中填写测试邮件接收人。',
  'ACTIVITY.MANAGE.SEND.TEST.TIPS':
    '已经自动为您拉取测试人名单和资源码<br/>测试人名单：邮件内容只发给对应语种的测试人；如需调整此页面可直接删减测试人邮箱。',
  'ACTIVITY.MANAGE.SEND.NOW': '现在发送',
  'ACTIVITY.MANAGE.TEST.MAIL.FROM': '来自',
  // 预览并测试 - 验证活动 - end

  // 活动管理 - 创建活动 - 提交验证
  'ACTIVITY.MANAGE.DATA.EXCEPTION': '数据异常，请检查{module}',
  'ACTIVITY.MANAGE.BE.DEL.REGION': '{name}地点有误，请检查{module}',

  // 活动管理 - 创建活动 - 标题
  'ACTIVITY.MANAGE.CREATE.NAME': '活动名称',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME': '输入活动名称',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME.DISABLED': '请输入活动名称',
  'ACTIVITY.MANAGE.PLEASES.ENTER.NAME.LIMIT': '请输入活动名称，上限50字符',

  // 活动管理 - 创建活动 - 发送给
  'ACTIVITY.MANAGE.TO': '发送给',
  'ACTIVITY.MANAGE.TO.TIPS': '您要把活动发给谁？',
  'ACTIVITY.MANAGE.TO.TIPS1': '此人数会在活动开始后自动更新',
  'ACTIVITY.MANAGE.STATISTICS.SUBSCRIBERS': '订阅者',
  'ACTIVITY.MANAGE.STATISTICS.CONTACTS': '联系人',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO': '发送给',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO.PLACEHOLDER': '请选择',
  'ACTIVITY.MANAGE.STATISTICS.SEND.TO.SEARCH.PLACEHOLDER': '请输入',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT': '目标联系人',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.LIST.NAME': '目标联系人{num}',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.TIPS':
    '活动内创建的目标联系人仅可在此活动使用',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.CREATE': '创建目标联系人',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.EDIT': '编辑目标联系人',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.VIEW': '预览目标联系人',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.VIEW.TIPS': '请先完成规则创建',
  'ACTIVITY.MANAGE.STATISTICS.BUILT.IN.SEGMENT.SUB': '应用目标联系人',
  'ACTIVITY.MANAGE.COUNTRY.LANG.STATISTICS':
    '总计 <b class="color-primary font-size-20 font-poppins">{total}</b> 个订阅者',
  'ACTIVITY.MANAGE.CONTACTS.WITH.TAG': '标签',
  'ACTIVITY.MANAGE.SEGMENT': '分层规则',
  'ACTIVITY.MANAGE.ALL.CONTACTS': '全部联系人',
  'ACTIVITY.MANAGE.PLEASE.ALL.CONTACTS': '请选择订阅状态',
  'ACTIVITY.MANAGE.SUBSCRIBERS': '已订阅联系人',
  'ACTIVITY.MANAGE.ALL.CONTACTS.AND.OTHER': '全部联系人（包含所有订阅状态）',
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.HEADER':
    '确定是否选择“全部联系人（包含所有订阅状态）”?',
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.TIPS1':
    '您选择向所有状态的联系人发送邮件，包括“已订阅”、“未订阅”和“状态未知”。',
  'ACTIVITY.MANAGE.ALL.CONTACTS.DIALOG.TIPS2':
    '请注意，向“未订阅”或“状态未知”的联系人发送邮件可能导致投诉，请谨慎操作。',
  'ACTIVITY.MANAGE.ALL.CONTACTS.DETAILS':
    '订阅状态（<span class="color-999">{typeText}</span>）',
  'ACTIVITY.MANAGE.PLEASE.SELECT.SEGMENT': '请选择分层',
  'ACTIVITY.MANAGE.EXPECTED.DELIVERY.DAYS1':
    '预计<b class="font-poppins">{num}天</b>内投递完所有用户',
  'ACTIVITY.MANAGE.ST.NUMBER.OF.PEOPLE': '人数',
  'ACTIVITY.MANAGE.ST.RATIO': '占比',
  'ACTIVITY.MANAGE.CONTACT.LIST': '联系名单',
  'ACTIVITY.MANAGE.CREATE.TAG': '创建一个新标签',
  'ACTIVITY.MANAGE.CREATE.SEGMENT': '创建一个新的分层规则',
  'ACTIVITY.MANAGE.BE.DEL.TAG': '{name}标签已被删除',
  'ACTIVITY.MANAGE.BE.DEL.SEGMENT': '{name}分层已被删除',

  // 活动管理 - 创建活动 - 来自
  'ACTIVITY.MANAGE.FROM': '来自',
  'ACTIVITY.MANAGE.FROM.TIPS': '发送活动的是谁？',
  'ACTIVITY.MANAGE.PLEASE.SELECT.FROM.NAME': '请选择发件人名称',
  'ACTIVITY.MANAGE.PLEASE.SELECT.PREFIX.EMAIL.ADDRESS':
    '请选择发送电子邮件地址',
  'ACTIVITY.MANAGE.PLEASE.SELECT.DOMAIN': '请选择发送电子邮件地址的域名',
  'ACTIVITY.MANAGE.PLEASE.ENTER.DOMAIN': '请输入电子邮件地址的域名',
  'ACTIVITY.MANAGE.VERIFY.DOMAIN': '验证域名',
  'ACTIVITY.MANAGE.VERIFY.UNVERIFIED.DOMAIN': '域名未验证',
  'ACTIVITY.MANAGE.CREATE.NEW.SENDER.NAME': '创建一个新的发件人名称',
  'ACTIVITY.MANAGE.CREATE.NEW.SENDING.ADDRESS': '创建一个新的电子邮件地址',
  'ACTIVITY.MANAGE.CREATE.NEW.DOMAIN.NAME': '创建一个新的域名',
  'ACTIVITY.MANAGE.CREATE.SENDER': '发件人',
  'ACTIVITY.MANAGE.CREATE.SENDER.TIPS':
    '发件人名称（例如您的公司名称）帮助活动收件人在他们的收件箱里识别你。',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDER': '请输入或选择发件人',
  'ACTIVITY.MANAGE.CREATE.SENDER.NAME': '发件人名称',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDER.NAME': '请输入发件人名称',
  'ACTIVITY.MANAGE.CREATE.SENDER.MANAGE': '常用发件人管理',
  'ACTIVITY.MANAGE.CREATE.SENDER.ADDRESS.DELTIPS': '确定删除此发件人吗?',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS': '发件地址',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.TIPS':
    '收到活动时，选择在收件人的收件箱中出现的电子邮件地址。',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.SENDING.ADDRESS': '请输入发件地址',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.MANAGE': '常用发件地址管理',
  'ACTIVITY.MANAGE.CREATE.SENDING.ADDRESS.DELTIPS': '确定删除此发件地址吗?',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.MAIL.PREFIX': '请输入或选择邮件前缀',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.MAIL.SUFFIX': '请选择邮件后缀',
  'ACTIVITY.MANAGE.CREATE.INBOX': '收件箱',
  'ACTIVITY.MANAGE.CREATE.EMAIL.PROJECT': '邮件主题',
  'ACTIVITY.MANAGE.CREATE.YOU.PREVIEW.TEXT': '你的预览文本',
  'ACTIVITY.MANAGE.CREATE.MESSAGE.SUBJECT.AND.CONTENT': '主题及内容...',
  'ACTIVITY.MANAGE.CREATE.INBOX.TIPS':
    '实际的电子邮件预览可能取决于电子邮件客户端。',
  'ACTIVITY.MANAGE.CREATE.SENDING.SUBSCRIPTION_TITlE': '开启列表取消订阅	',
  'ACTIVITY.MANAGE.CREATE.SENDING.SUBSCRIPTION_MSG':
    "	开启后，收件人可在客户端的收件列表上一键取消订阅，客户端支持情况请到用户手册中查看。<a href={url} target='_black'>查看详情</a>",

  // 活动管理 - 创建活动 - 选择内容
  'ACTIVITY.MANAGE.CONTENT': '内容',
  'ACTIVITY.MANAGE.CONTENT.TIPS': '可为不同语种的收件人分别配置发件主题和模板',
  'ACTIVITY.MANAGE.AB.TEST.CONTENT.TIPS':
    '可为不同语种的收件人分别配置邮件模板',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.LANGUAGE': '默认语言',
  'ACTIVITY.MANAGE.CREATE.MAIL.CONTENT': '邮件内容',
  'ACTIVITY.MANAGE.CREATE.MAIL.WHATSAPP.TEMPLATE': 'WhatsApp模板',
  'ACTIVITY.MANAGE.CREATE.MAIL.SUBJECT': '主题',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.MAIL.SUBJECT': '请输入主题',
  'ACTIVITY.MANAGE.CREATE.SUBJECT.EXIST': '当前输入的主题已存在',
  'ACTIVITY.MANAGE.CREATE.SUBJECT.REPETITION': '{lang}主题存在重复项',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEXT': '预览文本',
  'ACTIVITY.MANAGE.CREATE.PREVIEW.TEXT.TIPS':
    '若未填写，则系统会自动截取邮件开头的文本',
  'ACTIVITY.MANAGE.CREATE.REPLY.TO.TEXT': '回复邮箱',
  'ACTIVITY.MANAGE.CREATE.REPLY.TO.TIPS': '请提供一个可联系的邮箱地址',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.PREVIEW.TEXT': '请输入预览文本',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.PREVIEW.TEXT.TIPS': '主题下方的预览文本',
  'ACTIVITY.MANAGE.CREATE.XX.LANGUAGE.RECIPIENTS': '{lang}收件人邮箱',
  'ACTIVITY.MANAGE.CREATE.MAIL.TEMPLATE': '模板',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.TEMPLATE': '请选择营销模板',
  'ACTIVITY.MANAGE.CREATE.TEMPLATE.TIME.SAVE': '{time} 保存',
  'ACTIVITY.MANAGE.CREATE.PLEASE.CHECK.TEMPLATE':
    '请检查邮件模板是否符合发布要求',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TITLE': '模板检查项',
  'ACTIVITY.MANAGE.CONTENT.ERROR.DETECTED': '存在问题',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS1': '邮件内容中应该包括一个取消订阅链接',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS1.1': '取消订阅链接已添加到电子邮件',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS2': '检测到未创建的资源码/联系人字段',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS2.1': '资源码已全部创建',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS3': '模板已被删除',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS4':
    '模板包含资源码：<p class="red-dot created-var" title={variable}>{variable}</p>',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS4.1':
    '资源码用完会导致活动暂停，活动开始后请确保资源码赋值数量充足。',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS5': '模板包含未激活表单',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS6': '检测到未创建的联系人字段',
  'ACTIVITY.MANAGE.CONTENT.COPY.LINK': '复制链接',
  'ACTIVITY.MANAGE.CONTENT.COPY.LINK.DETAILS': '请先完成邀请链接的配置',
  'ACTIVITY.MANAGE.CONTENT.TEMP.TIPS6.1': '此模板中未添加邀请链接',

  'ACTIVITY.MANAGE.CONTENT.EDIT.TEMP': '编辑',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.PER': '个人信息',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.TITLE': '插入个人信息',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.DESC': '请选择动态值占位符',
  'ACTIVITY.MANAGE.CONTENT.PLACEHOLDER.ADD': '新增占位符',
  'ACTIVITY.MANAGE.CREATE.ETC.CONTENTS': '等 {num} 个邮件模版',
  'ACTIVITY.MANAGE.CREATE.LANGUAGES': '语言',
  'ACTIVITY.MANAGE.CREATE.FILLED.IN.NUM': '已填写',
  'ACTIVITY.MANAGE.SET.BY.LANGUAGE.TIPS':
    '收件人语言为未知语言或未设置收件人语言的模板时，为收件人发送此语言下选中模板。',

  // 活动管理 - 创建活动 - 时间安排
  'ACTIVITY.MANAGE.SCHEDULE': '时间安排',
  'ACTIVITY.MANAGE.SCHEDULE.TIPS': '什么时间发送活动？',
  'ACTIVITY.MANAGE.AB.TEST.SCHEDULE.TIPS': '什么时间发送测试？',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE': '计划',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE.DESC':
    '不同的发件时间选项，会影响选出获胜组后的发件时间。',
  'ACTIVITY.MANAGE.RADIO.SCHEDULE.TIPS':
    '如果按联系人当地时间或最佳发件时间设置发件时间，则获胜组选出后会等待设置的时刻到达后开始剩余用户的发件。如果选择全球固定时间，则获胜组选出后会立即开始发件。',
  'ACTIVITY.MANAGE.RADIO.SEND.NOW': '立即发送',
  'ACTIVITY.MANAGE.DELIVER.TIME': '送达时间',
  'ACTIVITY.MANAGE.DUPLICATE.REMOVAL': '重复发送邮件给符合条件的收件人',
  'ACTIVITY.MANAGE.NOT.DUPLICATE.REMOVAL':
    '过滤已经在过去周期内收到邮件的收件人',
  'ACTIVITY.MANAGE.CREATE.NEW.SCHEDULE': '创建新计划',
  'ACTIVITY.MANAGE.SCHEDULE.NUM': '计划{num}',

  'ACTIVITY.MANAGE.CREATE.DELIVERY.TIME': '递送时间',
  'ACTIVITY.MANAGE.CREATE.FIXED.TIME.ZONE': '全球固定时间',
  'ACTIVITY.MANAGE.CREATE.SELECT.TIME.ZONE': '选择时区',
  'ACTIVITY.MANAGE.CREATE.SELECT.START.DELIVERY.TIME': '递送时间',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.SCHEDULE': '默认计划',
  'ACTIVITY.MANAGE.CREATE.DEFAULT.SCHEDULE.TIPS':
    '设置完成后，未知国家，和后续新增未设置的国家时间均按此处设置时间发送邮件',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.DEFAULT.SCHEDULE': '请选择默认计划',
  'ACTIVITY.MANAGE.CREATE.STOP.DELIVERY.TIME': '结束时间',
  'ACTIVITY.MANAGE.CREATE.CYCLE.SETTING': '周期设置',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.TITLE':
    '周期间联系人去重逻辑设置',
  'ACTIVITY.MANAGE.CREATE.DUPLICATE.REMOVAL': '去重',
  'ACTIVITY.MANAGE.CREATE.NO.WEIGHT.LOSS': '不去重',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.1': '永久去重',
  'ACTIVITY.MANAGE.CREATE.DEDUPLICATION.LOGIC.2': '以天数为周期，周期内去重',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.DAY': '输入天数',
  'ACTIVITY.MANAGE.CREATE.ENTER.MIN.DAY': '请输入大于{minNum}天数',
  'ACTIVITY.MANAGE.CREATE.ENTER.MIN.DAY.TIPS': '去重周期的天数应大于发件周期',
  'ACTIVITY.MANAGE.CREATE.DAY': '天数',
  'ACTIVITY.MANAGE.CREATE.SPECIFIED.SCHEDULE': '指定时间表',
  'ACTIVITY.MANAGE.CREATE.TOTAL.CYCLES.NUMBER': '总计周期数：<b>{num}</b>',

  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.STOP.DELIVERY.TIME': '请选择结束时间',
  'ACTIVITY.MANAGE.CREATE.BY.USER.TIME.ZONE': '联系人当地时间',
  'ACTIVITY.MANAGE.CREATE.BY.USER.TIME.ZONE.TIPS':
    '无地区的联系人默认按UTC+00:00设置',

  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION': '当地时间',
  'ACTIVITY.MANAGE.CREATE.OPTIMAL.SENDING.TIME': '最佳发件时间',
  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION.TIPS':
    '只需选择发送日期，系统为您推荐不同地区的最佳送达时间',
  'ACTIVITY.MANAGE.CREATE.CONFIGURE.BY.COUNTRY.REGION.DESC':
    '至少提前24小时设置发送时间，以获得最大化参与度的最佳发送时间。',
  'ACTIVITY.MANAGE.CREATE.EARLIEST.DELIVERY.TIME': '最早投递时间',
  'ACTIVITY.MANAGE.CREATE.SHOW.SUGGESTED.SCHEDULE': '展示建议时间表',
  'ACTIVITY.MANAGE.CREATE.SET.START.DELIVERY.TIME':
    '设置投递开始时间（当地时间）',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SET.START.DELIVERY.TIME': '请设置开始投递时间',
  'ACTIVITY.MANAGE.CREATE.SET.START.DELIVERY.DATE': '设置开始投递日期',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SET.START.DELIVERY.DATE': '请设置开始投递日期',
  'ACTIVITY.MANAGE.CREATE.PLEASE.ENTER.COUNTRY.REGION': '请输入地点名称',
  'ACTIVITY.MANAGE.SCHEDULE.START.TIME.COMPARE.TIPS':
    '开始时间不能大于结束时间',
  'ACTIVITY.MANAGE.SCHEDULE.STOP.TIME.COMPARE.TIPS': '结束时间不能小于开始时间',

  'ACTIVITY.MANAGE.CREATE.START.DELIVERY.TIME1': '递送开始时间（当地时区）',
  'ACTIVITY.MANAGE.CREATE.START.DELIVERY.TIME2': '递送开始时间',
  'ACTIVITY.MANAGE.CREATE.DELIVERED.QUANTITY': '已投递数量',
  'ACTIVITY.MANAGE.CREATE.DELIVERED.PROPORTION': '已投递比例',
  'ACTIVITY.MANAGE.CREATE.PLEASE.COUNTRY.REGION.DELIVERY':
    '请配置地点的开始投递时间',
  'ACTIVITY.MANAGE.CREATE.DELIVERY.CYCLE': '递送周期',
  'ACTIVITY.MANAGE.CREATE.PLEASE.SELECT.DELIVERY.CYCLE': '请选择递送周期',
  'ACTIVITY.MANAGE.CREATE.SINGLE.TIME': '单次发送',
  'ACTIVITY.MANAGE.CREATE.EVERY.DAY': '每天发送',
  'ACTIVITY.MANAGE.CREATE.WEEKLY': '每周发送',
  'ACTIVITY.MANAGE.CREATE.MONTHLY': '每月发送',

  // 禁发时段设置
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.SETTING': '禁发时段设置',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD': '禁发时段',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.SETTING.TIPS':
    '可在此处设置禁发时间段，按地区设置，地区未知的用户不受禁发功能保护',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM': '从',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO': '到',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TOTAL': '总计',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.HOUR.MINUTES': '{hours}小时{minutes}分钟',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.HOUR': '{hours}小时',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.MINUTES': '{minutes}分钟',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM.TIME.COMPARE.TIPS':
    '开始时间不能大于结束时间',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO.TIME.COMPARE.TIPS':
    '结束时间不能小于开始时间',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.FROM.EQ.TIME.TIPS':
    '开始时间不能等于结束时间',
  'ACTIVITY.MANAGE.BLACKOUT.PERIOD.TO.EQ.TIME.TIPS': '结束时间不能等于开始时间',

  // 审批管理 - 列表
  'ACTIVITY.MANAGE.APPROVAL.TITLE': '审批活动列表',
  'ACTIVITY.MANAGE.APPROVAL.ID': '活动ID',
  'ACTIVITY.MANAGE.APPROVAL.NAME': '活动名称',
  'ACTIVITY.MANAGE.APPROVAL.CATEGORY': '分类',
  'ACTIVITY.MANAGE.APPROVAL.REGULAR': '常规',
  'ACTIVITY.MANAGE.APPROVAL.TEST': '测试',
  'ACTIVITY.MANAGE.APPROVAL.CYCLE': '周期',
  'ACTIVITY.MANAGE.APPROVAL.START.TIME': '活动开始时间',
  'ACTIVITY.MANAGE.APPROVAL.SUBMIT.TIME': '审批提交时间',
  'ACTIVITY.MANAGE.APPROVAL.SUBMITTER': '提交人',
  'ACTIVITY.MANAGE.APPROVAL.STATUS': '状态',
  'ACTIVITY.MANAGE.APPROVAL.TIME': '审批时间',
  'ACTIVITY.MANAGE.APPROVER': '审批人',
  'ACTIVITY.MANAGE.TO.BE.APPROVED': '待审批',
  'ACTIVITY.MANAGE.PASSED': '已通过',
  'ACTIVITY.MANAGE.REJECTED': '已驳回',
  'ACTIVITY.MANAGE.TO.APPROVE': '审批',
  'ACTIVITY.MANAGE.DISABLED': '已禁用',

  // 审批管理 - 详情
  'ACTIVITY.MANAGE.CURRENT.PROGRESS': '当前进度',
  'ACTIVITY.MANAGE.APPLICATION.RELEASE': '申请发布',
  'ACTIVITY.MANAGE.UNDER.APPROVAL': '审批中',
  'ACTIVITY.MANAGE.APPROVAL.ADOPT': '通过（发布完成）',
  'ACTIVITY.MANAGE.APPROVAL.FAIL': '不通过',
  'ACTIVITY.MANAGE.MODIFY.ACTIVITY.REAPPLICATION': '修改活动重新申请',

  'ACTIVITY.MANAGE.APPLICATION.OVERVIEW': '申请概况',
  'ACTIVITY.MANAGE.APPLICANT': '申请人',
  'ACTIVITY.MANAGE.APPLICATION.TIME': '申请时间',
  'ACTIVITY.MANAGE.EDITED.BY': '最近编辑人',
  'ACTIVITY.MANAGE.REJECTION.RECORD': '驳回记录',
  'ACTIVITY.MANAGE.REJECTION.NUMBER':
    '驳回<span class="tea-text-danger">{rejectTimes}</span>次',

  'ACTIVITY.MANAGE.APPROVAL.MODAL.TITLE': '确定审批结果',
  'ACTIVITY.MANAGE.APPROVAL.RESULTS': '审批结果',
  'ACTIVITY.MANAGE.APPROVAL.REASON.1': '原因',
  'ACTIVITY.MANAGE.APPROVAL.REASON.2': '原因<span>（选填）</span>',
  'ACTIVITY.MANAGE.PLEASE.ENTER.APPROVAL.REASONS': '请输入原因',

  'ACTIVITY.MANAGE.UPDATE.ON': '更新于',
  'ACTIVITY.MANAGE.OVER.MILLION.TIPS':
    '收件人数量超过100万，请在发布前联系<span class="color-primary">{customerServiceEmail}</span>确认项目可发件额度，否则可能会由于额度受限导致发件中断。',
  // WhatsApp hover文案
  'ACTIVITY.WHATSAPP.LIST.DRAFT.NOTE':
    '活动未创建完成，编辑后可直接发布或申请发布。',
  'ACTIVITY.WHATSAPP.LIST.SCHEDULED.NOTE':
    '活动发布成功，但是未到设置的发送时间，未开始投递。',
  'ACTIVITY.WHATSAPP.LIST.SENDING.ONGOING.NOTE':
    '活动被发布成功，且已经到达设置的发送时间，正常投递中。',
  'ACTIVITY.WHATSAPP.LIST.PAUSED.NOTE':
    '进行中的活动，被手动暂停。当前不再发送消息。',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED.NOTE':
    '进行中的活动，但由于账号限制等问题导致发送被中断。',
  'ACTIVITY.WHATSAPP.LIST.COMPLETED.NOTE': '活动已结束。',
  'ACTIVITY.WHATSAPP.LIST.TERMINATED.NOTE': '活动被手动终止。',
  // hover标题(补充)
  'ACTIVITY.WHATSAPP.LIST.SENDING': '发送中',
  'ACTIVITY.WHATSAPP.LIST.PAUSEDTIP': '已暂停',
  'ACTIVITY.WHATSAPP.LIST.INTERRUPTED': '发送中断',

  'ACTIVITY.MANAGE.CONTENT.VERIFY.KEYS.TIPS': '检测到未创建的资源码',
  'ACTIVITY.MANAGE.CONTENT.VERIFY.ATTRIBUTES.TIPS': '联系人字段默认值未设置',
  'ACTIVITY.MANAGE.CONTENT.CONTAINS.ATTRIBUTES.TIPS': '资源码',
  'ACTIVITY.MANAGE.CONTENT.CONTAINS.ATTRIBUTES.DES':
    '使用资源码会导致活动暂停。请检查资源码的分配是否符合活动要求。',
};
